import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const namespaced = true
const _snapshot = 'snapshot'

const state = {
  _snapshot,
  [_snapshot]: {
    data: {},
    fetching: false
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reports/index.js